import React from 'react';
import { LayoutGrid, List } from 'lucide-react';
import { VIEW_TILES, VIEW_LIST } from '@/hooks/useProjectViewMode';

/**
 * Two buttons: tiles or list. The pressed one is filled in.
 *
 * `aria-pressed` is what a test - and a screen reader - reads to tell which
 * view is on, since the difference is otherwise only a background colour.
 */
export default function ProjectViewToggle({ value, onChange }) {
  const options = [
    { mode: VIEW_TILES, icon: LayoutGrid, label: 'Tile view' },
    { mode: VIEW_LIST, icon: List, label: 'List view' },
  ];

  return (
    <div className="inline-flex items-center rounded-lg border bg-card p-0.5">
      {options.map(({ mode, icon: Icon, label }) => {
        const active = value === mode;
        return (
          <button
            key={mode}
            type="button"
            onClick={() => onChange(mode)}
            aria-pressed={active}
            aria-label={label}
            title={label}
            className={`flex items-center justify-center rounded-md p-1.5 transition-colors ${
              active
                ? 'bg-accent text-accent-foreground'
                : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            <Icon className="w-4 h-4" />
          </button>
        );
      })}
    </div>
  );
}
